import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Image from 'next/image';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import IconEmail from '@/assets/icons/heroIcons/Mail.svg';
import IconUser from '@/assets/icons/heroIcons/User-circle.svg';
import { SectionHeadline } from '@/components/SectionHeadline';
import { DownloadButton } from '@/components/buttons';
import { Text } from '@/components/typography';
import { getAnchorId } from '@/utils/anchors';
function Contact() {
  const $ = _c(84);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["forJournalists"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("contactSection.ceo.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="mb-8 lg:mb-0 lg:flex-[0_0_28.5rem]"><Image src="/images/sections/forJournalists/ceo.png" alt={t1} width="456" height="342" /></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("contactSection.ceo.message");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="mb-4 text-center text-lg font-bold text-white lg:mb-6 lg:text-left lg:text-2xl">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("contactSection.ceo.name");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <span className="text-xs font-semibold lg:text-base">{t5}</span>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("contactSection.ceo.company");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <span className="text-xs lg:text-base">{t8}</span>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <p className="text-center text-white lg:text-left">{t6}{t7}{t9}</p>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t4) {
    t11 = <div>{t4}{t10}</div>;
    $[21] = t10;
    $[22] = t4;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t2) {
    t12 = <div className="mx-auto mb-14 max-w-[21.5rem] rounded-3xl bg-blue-500 px-4 pt-4 pb-8 lg:mb-20 lg:flex lg:max-w-[73rem] lg:items-center lg:gap-20 lg:rounded-[2.5rem] lg:py-8 lg:pr-20 lg:pl-8">{t2}{t11}</div>;
    $[24] = t11;
    $[25] = t2;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = getAnchorId("contactSection.title");
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("contactSection.title");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = <SectionHeadline className="mb-4 px-0" anchorKey="contactSection.title" id="contact-mobile">{t14}</SectionHeadline>;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Link to={LINKS().contact} testId="contactSectionContact" analyticsParam="contactSectionContact" />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = <Text variant="p2" className="mb-6 text-center text-gray-800"><Trans i18nKey="forJournalists:contactSection.description" t={t}>{t16}</Trans></Text>;
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17) {
    t18 = <div className="lg:hidden">{t15}{t17}</div>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t("contactSection.spokesperson.name");
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t19) {
    t20 = <div className="xl:flex-[0_0_35.5rem]"><Image src="/images/sections/forJournalists/spokenPerson.png" alt={t19} width="568" height="590" className="mx-auto max-w-xs lg:max-w-none" /></div>;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("contactSection.title");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21) {
    t22 = <SectionHeadline className="pb-4 text-left" anchorKey="contactSection.title" id="contact-desktop">{t21}</SectionHeadline>;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Link to={LINKS().contact} testId="contactSectionContact" analyticsParam="contactSectionContact" />;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t) {
    t24 = <Text variant="p2" className="mb-12 text-left text-gray-800"><Trans i18nKey="forJournalists:contactSection.description" t={t}>{t23}</Trans></Text>;
    $[47] = t;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t22 || $[50] !== t24) {
    t25 = <div className="hidden lg:block">{t22}{t24}</div>;
    $[49] = t22;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <span className="hidden text-blue-500 lg:mt-1 lg:block"><IconUser /></span>;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t) {
    t27 = t("contactSection.spokesperson.name");
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t27) {
    t28 = <strong className="pb-1 font-semibold lg:pb-0">{t27}</strong>;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t) {
    t29 = t("contactSection.spokesperson");
    $[57] = t;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t29) {
    t30 = <Text as="span" variant="p3" className="mb-2 text-gray-700">{t29}</Text>;
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t28 || $[62] !== t30) {
    t31 = <div className="lg:flex lg:flex-row lg:gap-3">{t26}<div className="flex flex-col">{t28}{t30}</div></div>;
    $[61] = t28;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="flex flex-row items-center justify-center gap-2 text-blue-500 lg:justify-start lg:gap-3"><IconEmail /><Link to="mailto:pr@skippay.cz" testId="contactSectionPREmail" analyticsParam="contactSectionPREmail">pr@skippay.cz</Link></div>;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t31) {
    t33 = <div className="mx-auto flex w-full max-w-md flex-col rounded-2xl bg-blue-50 px-6 py-4 text-center lg:mx-0 lg:rounded-3xl lg:py-6 lg:text-left lg:text-xl">{t31}{t32}</div>;
    $[65] = t31;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== t) {
    t34 = t("contactSection.spokesperson.download");
    $[67] = t;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t34) {
    t35 = <DownloadButton to="/images/sections/forJournalists/downloads/cs/Frantisek_Broz.jpg" testId="downloadsSectionDownloadPhoto" analyticsParam="downloadsSectionDownloadPhoto" className="mt-12">{t34}</DownloadButton>;
    $[69] = t34;
    $[70] = t35;
  } else {
    t35 = $[70];
  }
  let t36;
  if ($[71] !== t25 || $[72] !== t33 || $[73] !== t35) {
    t36 = <div className="xl:flex-[0_0_29.25rem]">{t25}{t33}{t35}</div>;
    $[71] = t25;
    $[72] = t33;
    $[73] = t35;
    $[74] = t36;
  } else {
    t36 = $[74];
  }
  let t37;
  if ($[75] !== t20 || $[76] !== t36) {
    t37 = <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between lg:gap-12 lg:pt-20">{t20}{t36}</div>;
    $[75] = t20;
    $[76] = t36;
    $[77] = t37;
  } else {
    t37 = $[77];
  }
  let t38;
  if ($[78] !== t18 || $[79] !== t37) {
    t38 = <div className="mx-auto mt-20 lg:max-w-[73rem]" id={t13}>{t18}{t37}</div>;
    $[78] = t18;
    $[79] = t37;
    $[80] = t38;
  } else {
    t38 = $[80];
  }
  let t39;
  if ($[81] !== t12 || $[82] !== t38) {
    t39 = <div className="relative z-10 bg-blue-100 px-4 py-14 lg:py-20">{t12}{t38}</div>;
    $[81] = t12;
    $[82] = t38;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  return t39;
}
export default Contact;